module.exports = __webpack_public_path__ + "img/hr-centrifuge-C.eb2d70f6.png";